module.exports = __webpack_public_path__ + "assets/img/title.2a7b03b3.png";